import { DatesProvider } from "@mantine/dates"
import dayjs from "dayjs"

const getBrowserLocale = (): string => {
  if (typeof window === "undefined") return "de-DE"
  const browserLang = navigator.language || "de-DE"

  return dayjs.locale(browserLang.toLowerCase())
}

export function MantineDatesProvider(props: React.PropsWithChildren) {
  const locale = getBrowserLocale()

  return <DatesProvider settings={{ locale }}>{props.children}</DatesProvider>
}
